import { createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const getOrgEntitlements = createApiAction(
  types.LOAD_ORG_ENTITLEMENTS,
  (payload) => api.getOrgEntitlements(payload),
);
